import { attendeeFetchData, attendeeSendData, attendeePutData } from "./index";

const licenseAPI = {
  fetch: (attendeeId) => attendeeFetchData(`/api/v2/attendees/${attendeeId}/license`),
  getCertificateLinks: (attendeeId) => attendeeFetchData(`/api/v2/attendees/${attendeeId}/certificate/info`),
  send: (attendeeId, data) => attendeePutData(`/api/v2/attendees/${attendeeId}/license`, data),
  fetchCertificate: (attendeeId) => attendeeFetchData(`/api/v2/attendees/${attendeeId}/certificate`,{
    responseType: 'blob'
  }).then((res)=>{
    let blob = new Blob([res.data], {
      type: 'application/pdf'
    })

    const link = window.document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = `certificate.pdf`
    link.click()
  }),
}

export default licenseAPI;